export default __webpack_public_path__ + "static/media/logo.97f6b49b.png";